import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "./PermissionHelper";

export interface IPermissionProps {
    userClaim: UserClaim | UserClaim[];
    children: JSX.Element | string;
    replaceChildren?: JSX.Element | string;
}

interface IPermissionState {
    hasPermission: boolean;
}

export class Permission extends BaseComponent<IPermissionProps, IPermissionState> {
    constructor(props: IPermissionProps) {
        super(props);
        this.state = {
            hasPermission: checkPermission(props.userClaim),
        };
    }

    render() {
        if (this.state.hasPermission == undefined) {return null;}
        const replace = this.props.replaceChildren || null;
        return this.state.hasPermission ? this.props.children : replace;
    }
}
